import { type AuthBindings } from "@refinedev/core";

import { API_URL } from "./env";

import { axiosInstance } from "rest-data-provider/utils";
import { QueryKeys } from "constants/keys";
import { queryClient } from "App";

import { LoginEntity, UserEntity } from "generated";

const logout = async () => {
  await axiosInstance.post(`${API_URL}/auth/logout`);
};

const authProvider: AuthBindings = {
  login: async ({ email, password }) => {
    try {
      const user = (
        await axiosInstance.post(`${API_URL}/auth/login`, {
          identifier: email,
          password,
        })
      ).data as LoginEntity;

      localStorage.setItem("auth", user.jwt);

      return {
        success: true,
        redirectTo: "/",
      };
    } catch (error) {
      return {
        success: false,
        error: {
          name: "Login Error",
          message: "Invalid email or password",
        },
      };
    }
  },
  check: async () => {
    const querydata = queryClient.getQueryData([QueryKeys.ME_QUERY]) as
      | UserEntity
      | undefined;

    if (querydata?.id) {
      return {
        authenticated: true,
      };
    }

    if (localStorage.getItem("auth")) {
      try {
        await queryClient.fetchQuery({
          queryKey: [QueryKeys.ME_QUERY],
          queryFn: async () =>
            (
              await axiosInstance.get(`${API_URL}/users/me`)
            ).data,
          cacheTime: Infinity,
        });

        return {
          authenticated: true,
        };
      } catch (error) {
        localStorage.removeItem("auth");
        queryClient.clear();
      }
    }

    return {
      authenticated: false,
      logout: true,
      redirectTo: "/login",
      error: {
        name: "Unauthorized",
        message: "Check failed",
      },
    };
  },
  logout: async () => {
    try {
      await logout();
    } catch (error) {}

    queryClient.clear();
    localStorage.removeItem("auth");

    return {
      success: true,
      redirectTo: "/login",
    };
  },
  onError: async (error) => {
    if (error.statusCode === 401 || error.statusCode === 403) {
      return {
        logout: true,
        redirectTo: "/login",
        error,
      };
    }
    return {};
  },
  getPermissions: async () => {
    const querydata = queryClient.getQueryData([QueryKeys.ME_QUERY]) as
      | UserEntity
      | undefined;

    return querydata?.id ? querydata.role : null;
  },
  getIdentity: async () => {
    const querydata = queryClient.getQueryData([QueryKeys.ME_QUERY]) as
      | UserEntity
      | undefined;

    if (querydata) {
      const { email, role, name, image, id } = querydata;
      return { id, email, role, name, avatar: image };
    }

    return null;
  },
};

export { authProvider };
